import { Options, js2xml as js2xmlLibrary } from 'xml-js';

export function decodeDDI(DDIstr: string) {
  return parseInt(DDIstr, 16);
}

export function encodeDDI(DDI: number) {
  return ('0000' + DDI.toString(16)).substr(-4).toUpperCase();
}

// escapes characters &'<> in attributes in place and calls the original js2xml function
// it's a workaround for https://github.com/nashwaan/xml-js/issues/69
export function js2xml(xml, options: Options.JS2XML): string {
  const updateNodeAttributes = (node) => {
    if (typeof node !== 'object') {
      return;
    }
    Object.keys(node)
      .filter((key) => key !== '_attributes' && key !== '_declaration')
      .forEach((childTag) => {
        if (Array.isArray(node[childTag])) {
          node[childTag].forEach(updateNodeAttributes);
        } else {
          updateNodeAttributes(node[childTag]);
        }
      });

    node._attributes &&
      Object.keys(node._attributes).forEach((name) => {
        if (typeof node._attributes[name] === 'string') {
          node._attributes[name] = node._attributes[name]
            .replace(/&/g, '&amp;')
            .replace(/'/g, '&apos;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;');
        }
      });
  };

  updateNodeAttributes(xml);
  return js2xmlLibrary(xml, options);
}
